import { msg } from '@lingui/core/macro';

export const RATING_SCALE_TABLE_ID = 'task-rating-scale-table';
export const RATING_SCALE_TABLE_HEADER_CELL_CLASS_NAME = 'task-rating-scale-table-header-cell';

export const SHARED_RATING_SCALE_RATING = msg`Rating`;
export const SHARED_RATING_SCALE_POINTS = msg`Points`;
export const SHARED_RATING_SCALE_DESCRIPTION = msg`Description`;
export const SHARED_RATING_SCALE_RATING_APPROVED = msg`Approved`;
export const SHARED_RATING_SCALE_MEETS_EXPECTED_CRITERIA_GUIDELINES = msg`Meets expected criteria as per the guidelines.`;
export const SHARED_RATING_SCALE_RATING_DISAPPROVED = msg`Disapproved`;
export const SHARED_RATING_SCALE_DOES_NOT_MEET_EXPECTED = msg`Does not meet expected criteria as per the guidelines.`;
export const SHARED_RATING_SCALE_RATING_EXCEPTIONAL = msg`Exceptional`;
export const SHARED_RATING_SCALE_CONSISTENTLY_EXCEEDS_REQUIRED_STANDARD = msg`Consistently exceeds the required standard`;
export const SHARED_RATING_SCALE_ACTS_ROLE_MODEL_GUIDES = msg`Acts as a role model / guides others`;
export const SHARED_RATING_SCALE_RATING_EXCEEDS_EXPECTATIONS = msg`Exceeds expectations`;
export const SHARED_RATING_SCALE_PERFORMS_ABOVE_REQUIRED_STANDARD = msg`Performs above the required standard`;
export const SHARED_RATING_SCALE_WORKS_INDEPENDENTLY_CONFIDENTLY = msg`Works independently and confidently`;
export const SHARED_RATING_SCALE_RATING_MEETS_EXPECTATIONS = msg`Meets expectations`;
export const SHARED_RATING_SCALE_PERFORMS_REQUIRED_STANDARD = msg`Performs to the required standard`;
export const SHARED_RATING_SCALE_RELIABLE_NORMAL_SITUATIONS = msg`Reliable in normal situations`;
export const SHARED_RATING_SCALE_RATING_NEEDS_IMPROVEMENT = msg`Needs improvement`;
export const SHARED_RATING_SCALE_PARTIALLY_MEETS_REQUIRED_STANDARD = msg`Partially meets the required standard`;
export const SHARED_RATING_SCALE_REQUIRES_GUIDANCE_SUPERVISION = msg`Requires guidance or supervision`;
export const SHARED_RATING_SCALE_RATING_UNSATISFACTORY = msg`Unsatisfactory`;
export const SHARED_RATING_SCALE_DOES_NOT_MEET_REQUIRED = msg`Does not meet the required standard`;
export const SHARED_RATING_SCALE_UNABLE_PERFORM_TASK_CORRECTLY = msg`Unable to perform the task correctly`;
